import DoIt from "../../../../contents/docs/cdp/sources/_snippets/source-doit.mdx";
import * as React from 'react';
export default {
  DoIt,
  React
};